import { render, staticRenderFns } from "./RegionPlacePicker.vue?vue&type=template&id=03fcee58&scoped=true"
import script from "./RegionPlacePicker.vue?vue&type=script&lang=ts"
export * from "./RegionPlacePicker.vue?vue&type=script&lang=ts"
import style0 from "./RegionPlacePicker.vue?vue&type=style&index=0&id=03fcee58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fcee58",
  null
  
)

export default component.exports